export default __webpack_public_path__ + "static/media/1404.8d50f294.png";